import Vue from "vue";
import { pageScroll } from "./../../assets/utils/utils";
import confirm from "./confirm.vue";
const ConfirmConstructor = Vue.extend(confirm);

const instance = new ConfirmConstructor({
  el: document.createElement("div")
});

const hashChange = function() {
  pageScroll.unlock();

  const el = instance.$el;
  el.parentNode && el.parentNode.removeChild(el);
};

ConfirmConstructor.prototype.closeConfirm = function(stay, callback) {
  let stopClose = true;

  if (typeof callback === "function") {
    stopClose = callback();
    if (stopClose === undefined) stopClose = true;
  }

  if (!stopClose || stay) return;

  pageScroll.unlock();

  const el = instance.$el;
  el.parentNode && el.parentNode.removeChild(el);

  window.removeEventListener("hashchange", hashChange);
};
ConfirmConstructor.prototype.close = function() {
  el.parentNode.removeChild(el);
};
const Confirm = (options = {}) => {
  instance.mes = options.mes || "";
  instance.title = options.title || "";
  if(typeof(options.opts[0].maskClick)=='undefined'){
    options.opts[0].maskClick=true
  }


  instance.opts = options.opts;
  window.addEventListener("hashchange", hashChange);

  document.body.appendChild(instance.$el);

  pageScroll.lock();
};

export default Confirm;
